"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.IDENTITY_TYPE_VALUE_INPUT_LABELS = exports.IDENTITY_TYPE_LABELS = void 0;
var account_api_1 = require("@newfront-insurance/account-api");
exports.IDENTITY_TYPE_LABELS = (_a = {},
    _a[account_api_1.IdentityType.BUSINESS_IDENTIFIER] = 'Business identifier',
    _a[account_api_1.IdentityType.DRIVERS_LICENSE] = "Driver's license",
    _a[account_api_1.IdentityType.PASSPORT] = 'Passport',
    _a[account_api_1.IdentityType.PERMANENT_RESIDENT_CARD] = 'Permanent resident card',
    _a[account_api_1.IdentityType.STATE_ID_CARD] = 'State ID card',
    _a[account_api_1.IdentityType.SSN] = 'Social Security Number',
    _a);
exports.IDENTITY_TYPE_VALUE_INPUT_LABELS = (_b = {},
    _b[account_api_1.IdentityType.BUSINESS_IDENTIFIER] = 'Business identifier number',
    _b[account_api_1.IdentityType.DRIVERS_LICENSE] = "Driver's license number",
    _b[account_api_1.IdentityType.PASSPORT] = 'Passport number',
    _b[account_api_1.IdentityType.PERMANENT_RESIDENT_CARD] = 'Permanent resident card number',
    _b[account_api_1.IdentityType.STATE_ID_CARD] = 'State ID card number',
    _b[account_api_1.IdentityType.SSN] = 'Social Security Number',
    _b);
//# sourceMappingURL=by-type.js.map